import styles from './skeletonLoader.module.scss';

interface SkeletonCardProps {
  className?: string
}

export function SkeletonCard({ className }: Readonly<SkeletonCardProps>) {
  return (
    <div className={`${styles.skeletonCard} ${className}`}>
      <div className={styles.skeletonLogo}></div>
      <div className={styles.skeletonTitle}></div>
      <div className={styles.skeletonText}></div>
      <div className={styles.skeletonButton}></div>
    </div>
  )
}

interface SkeletonGridProps {
  count?: number
  className?: string
}

export function SkeletonGrid({ count = 6, className }: Readonly<SkeletonGridProps>) {
  return (
    <div className={`${styles.skeletonGrid} ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={index} />
      ))}
    </div>
  )
}